import {
  Component,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { DialogService } from "src/app/services/dialog.service";
import { MotorService } from "src/app/services/perfilamiento/motor.service";
import { getFilesByFolder, itemFile } from "../../models/busCarpeta.interface";
import { BuscCarpetaService } from "src/app/services/perfilamiento/busc-carpeta.service";
import { DataService } from "../../services/data.service";
import { ReconocerService } from "src/app/services/preOferta/reconocer.service";
import { GetInformacionService } from "src/app/services/perfilamiento/get-informacion.service";
import { ResumenAdoService } from "../../services/resumen-ado.service";
import { PdfViewerComponent } from "ng2-pdf-viewer";
import { Location } from "@angular/common";
import { ResendMessageService } from "src/app/services/resend-message.service";

@Component({
  selector: "app-detalle-carpetas",
  templateUrl: "./detalle-carpetas.component.html",
  styleUrls: ["./detalle-carpetas.component.scss"],
})
export class DetalleCarpetasComponent {
  @ViewChild("generalTemplate", { static: true }) generalTemplate!: TemplateRef<any>;
  @ViewChild("motorTemplate", { static: true }) motorTemplate!: TemplateRef<any>;
  @ViewChild("carteraTemplate", { static: true }) carteraTemplate!: TemplateRef<any>;
  @ViewChild(PdfViewerComponent) pdfViewer?: PdfViewerComponent;

  myTabs: { title: string; content: TemplateRef<any> }[] = [];

  colorAdvertencia: "success" | "warning" | "info" = "success";
  textoAdvertencia = "";
  showAdvertencia: boolean = false;
  loadingAdvertencia = false;

  result: any;
  dataSource: any;
  listFiles: itemFile[];
  isLoading = false;
  page = 1;
  zoom = 100;
  activeIndex: number | null = null;
  selectedTabIndex: number = 0;

  constructor(
    private router: Router,
    private resendMessage: ResendMessageService,
    private dialogService: DialogService,
    private motorService: MotorService,
    private busService: BuscCarpetaService,
    public data: DataService,
    private reconocerSrvc: ReconocerService,
    private getinfoServ: GetInformacionService,
    private resumenAdoService: ResumenAdoService,
    private location: Location,
    private cd: ChangeDetectorRef
  ) {
    this.result = this.router.getCurrentNavigation()?.extras.state;
  }

  ngOnInit() {
    this.myTabs = [
      { title: "Información general", content: this.generalTemplate }
    ];
    this.getMotorDecision();
    this.getComprobantesCartera();
  }

  onTabChanged(index: number) {
    this.selectedTabIndex = index;
  }

  getMotorDecision() {
    this.motorService
      .getMotor(this.result.numeroCarpeta)
      .subscribe((res) => {
        this.dataSource = res.rows;
        if (this.dataSource.length > 0) {
          this.myTabs.push({ title: "Motor de decisión", content: this.motorTemplate })
        }
      });
  }

  async getComprobantesCartera() {
    const body: getFilesByFolder = {
      folder: this.result.numeroCarpeta.toString(),
      satelital: "buscar",
      originFolder: 4,
    };
    await this.busService
      .obtenerComprobantesPago(body)
      .then((res) => {
        this.listFiles = res;
        if (this.listFiles.length > 0) {
          this.myTabs.push({ title: "Comprobantes de compras de cartera", content: this.carteraTemplate })
        }
      })
      .catch((error) => {
        this.alerta(true)
        console.error(error);
      });
  }

  anteriorPagina() {
    if (this.page > 1) {
      this.page--;
    }
  }

  siguientePagina() {
    if (this.pdfViewer && this.pdfViewer?.pdfViewer.pagesCount > this.page) {
      this.page++;
    }
  }

  masZoom() {
    this.zoom += 10;
  }

  menosZoom() {
    this.zoom -= 10;
  }

  downloadPDF(file: string, nombreDocumento: string) {
    const link = document.createElement("a");
    link.href = file;
    link.target = "_blank";
    link.download = nombreDocumento;
    link.click();
  }

  toggle(index: number) {
    this.activeIndex = this.activeIndex === index ? null : index;
  }

  volverAtras() {
    this.location.back();
  }

  alerta(c: boolean) {
    this.colorAdvertencia = "info";
    this.textoAdvertencia = "Información no disponible, comunicate con tu coordinador.";
    this.showAdvertencia = true;
    this.loadingAdvertencia = false;
    this.cd.detectChanges();
  }

  async goStep() {
    this.isLoading = true;
    this.data.numeroCarpeta = this.result.numeroCarpeta;
    this.data.numeroSolicitud = this.result.numeroSolicitud;
    this.data.numeroIdentificacion = this.result.numeroDocumento;
    this.data.cedula = this.result.numeroDocumento;
    this.data.apellido = this.result.primerApellido;
    this.data.isResume = true;

    const response = await this.reconocerSrvc
      .reconoce(this.result.numeroSolicitud)
      .toPromise();
    this.data.setListadoCelulares(response.celulares);
    this.data.setListadoCorreos(response.correos);

    this.resumenAdoService.getResumenAd(this.data.numeroCarpeta).subscribe(
      async (resp: any) => {
        if (resp.marcaAuditoria === 1) {
          this.dialogService.openDialog(
            "Advertencia",
            "Carpeta se encuentra en validación. Intente mas tarde",
            false
          );
          this.isLoading = false;
          return;
        }

        switch (this.result.codigoEstado) {
          case 0:
            this.isLoading = false;
            this.router.navigateByUrl("/autorizacioncentral", {
              state: this.result,
            });
            break;
          case 20:
            this.getinfoServ
              .getInfoClient({ carpeta: this.data.numeroCarpeta.toString() })
              .subscribe((resp) => {
                this.isLoading = false;
                const info = resp.data.resultado.infoClient;
                this.data.numeroCarpeta = info.carpeta.toString();
                this.data.cellphone = info.celular.toString();
                const tries = resp.data.resultado.tries as any[];
                const otpTry = tries.find((t) => t.tipoValidacion === 4) || {
                  intentosActuales: 0,
                  totalIntentos: 0,
                };
                const whatsappTry = tries.find(
                  (t) => t.tipoValidacion === 6
                ) || { intentosActuales: 0, totalIntentos: 0 };

                this.data.isResume = !(
                  otpTry.intentosActuales === otpTry.totalIntentos &&
                  whatsappTry.intentosActuales === whatsappTry.totalIntentos
                );

                const route =
                  resp.data.resultado.logClient.status_process.viewRoute;
                this.router.navigateByUrl(`/${route}`, { state: { resp } });
              });
            break;

          case 30:
            this.isLoading = false;
            this.router.navigateByUrl("/formulario-perfilamiento", {
              state: this.result,
            });
            break;
          case 40:
            this.isLoading = false;
            this.router.navigateByUrl("/formulario-perfilamiento", {
              state: this.result,
            });
            break;
          case 100:
            this.isLoading = false;
            this.router.navigateByUrl("/formulario-perfilamiento", {
              state: this.result,
            });
            break;
          case 50:
            this.isLoading = false;
            this.router.navigateByUrl("/rob-analisis", {
              state: this.result,
            });
            break;
          case 150:
            this.isLoading = false;
            this.router.navigateByUrl("/pre-oferta", {
              state: this.result,
            });
            break;
          case 200:
            this.isLoading = false;
            this.router.navigateByUrl("/cargadocumentos", {
              state: this.result,
            });
            break;
          case 300:
            this.isLoading = false;
            if (resp.seizPagaduria === 1) {
              this.router.navigateByUrl("/oferta", {
                state: this.result,
              });
            } else {
              this.router.navigateByUrl("/informacionadicional", {
                state: this.result,
              });
            }
            break;
          case 600:
            this.isLoading = false;
            this.router.navigateByUrl("/saldo", {
              state: this.result,
            });
            break;
          case 700:
            this.isLoading = false;
            this.router.navigateByUrl("/informacionadicional", {
              state: this.result,
            });
            break;
          case 1300:
            this.isLoading = false;
            this.router.navigateByUrl("/pazysalvo", {
              state: this.result,
            });
            break;
          case 1200:
            this.obtenerUrlAdo()
            break;
          case 530:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 960:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 970:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 531:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 990:
            this.resumenAdoService
              .obtenerDocumentFisica({
                carpeta: this.data.numeroCarpeta,
              })
              .subscribe((resp) => {
                this.isLoading = false;
                if (resp.SOLICITA_DOC_FISICA == "SI") {
                  this.router.navigateByUrl("/firma-doc", {
                    state: this.result,
                  });
                } else {
                  this.dialogService.openDialog(
                    "Advertencia",
                    `Recuperar desde notificaciones, si deseas corregir una devolución`,
                    false
                  );
                }
              });
            break;
          case 980:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 550:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          default:
            this.isLoading = false;
            this.dialogService.openDialog(
              "Búsqueda de cartera",
              `La carpeta se encuentra ${this.result.estado}`,
              false
            );
            break;
        }
      },
      (err) => {
        this.dialogService.openDialog(
          "Error",
          JSON.stringify(err),
          false
        );
        this.isLoading = false;
      }
    );
  }

  obtenerUrlAdo() {
    this.isLoading = true
    this.resendMessage.getResendMessage(
      {
        numeroCarpeta: this.result.numeroCarpeta,
        status: this.result.codigoEstado
      }).subscribe((resp) => {
        this.isLoading = false;
        if (resp.status === 200) {
          this.dialogService.openDialogUrl(
            resp.message,
            "Si al solicitante no le llegó el sms o correo, por favor copia y pega la siguiente URL y compártela con tu cliente:",
            resp.url
          );
        } else {
          this.dialogService.openDialog(
            "Advertencia",
            `${resp.error.message[0].msg}`,
            false
          );
        }
      }, (err) => {
        this.isLoading = false;
        this.dialogService.openDialog(
          "Advertencia",
          `${err.error.message}`,
          false
        );
      }
      );
  }
}
